import { render, staticRenderFns } from "./account-report-detail-list.vue?vue&type=template&id=6fbece73&"
import script from "./account-report-detail-list.vue?vue&type=script&lang=ts&"
export * from "./account-report-detail-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports